import Vue from "vue";
import Vuex from "vuex";
import API_ATTRIBUTES from "../../api/attributes.api";

Vue.use(Vuex);

export const INITIAL_STATE = {
  attributes: [],
};

export default {
  state: () => ({ ...INITIAL_STATE }),
  getters: {
    attributes: (state) => state.attributes,
  },
  mutations: {
    fetch_attributes(state, newContent) {
      state.attributes = newContent ?? [];
    },
  },
  actions: {
    async fetch_attributes({ commit, getters }) {
      const response = await API_ATTRIBUTES.getAttributes(
        getters.selectedClient.id
      );
      commit("fetch_attributes", response);
      return "OK";
    },

    async post_attributes({ getters, dispatch }, data) {
      if (data.id) {
        await API_ATTRIBUTES.updateAttributes(getters.selectedClient.id, data);
      } else {
        await API_ATTRIBUTES.createAttributes(getters.selectedClient.id, data);
      }
      dispatch("fetch_attributes");
      return "OK";
    },

    async delete_attributes({ getters, dispatch }, attrId) {
      await API_ATTRIBUTES.deleteAttributes(getters.selectedClient.id, attrId);
      dispatch("fetch_attributes");
      return "OK";
    },
  },
};
